import { Contract, Phase, Segment } from "@/types/contract";
import { BundleServiceId, BundleServiceIdFVE, BundleServiceIdHeatPump } from "@/constants/supplyPoint";
import { SCREENS } from "./screens";
import { Product } from "@/types/enumerations";
import { PaymentTypeValues } from "@/constants/payments";
import { isValidRequestStatus } from "@/utils/request";
import { RequestStatusType } from "@/constants/request";
import { isS3PreviousCustomer } from "@/utils/contract";
import { isLDSEanOrEic } from "@/utils/supplyPoint";

export const showAttachmentsScreen = (contract?: Contract) => {
  const additionalDocuments = contract?.additionalDocuments ?? [];
  return additionalDocuments.length > 0;
};

export const showS3AttachmentsScreen = (contract?: Contract) => {
  const docs = contract?.previousCustomerAdditionalDocuments ?? [];
  return docs.length > 0;
};

export const isCustomerIdentified = (contract: Contract) => !!contract.contractDetails?.identificationFeActivation;
export const ocrSeen = (contract: Contract) => !!contract.ocrFeActivation;

export const isIdentifiedRequest = (contract: Contract) => {
  return contract.contractNumber !== "";
};

export const requireYearConsumption = (contract: Contract) => !contract.supplyPoint.yearConsumption;

export const redirectToSupplyPoint = (contract: Contract, products: Product[]) => {
  const isTariffWithBundleService =
    products.find(product => product.id === contract.contractDetails?.productId)?.bundleServices.includes(BundleServiceId) ===
    true;

  const isTariffWithBundleServiceForHeatPump =
    products
      .find(product => product.id === contract.contractDetails?.productId)
      ?.bundleServices.includes(BundleServiceIdHeatPump) === true;

  const isTariffWithBundleServiceFVE =
    products.find(product => product.id === contract.contractDetails?.productId)?.bundleServices.includes(BundleServiceIdFVE) ===
    true;
  return isTariffWithBundleService || isTariffWithBundleServiceForHeatPump || isTariffWithBundleServiceFVE;
};

export const requireInkasoSetup = (contract: Contract, products: Product[]) => {
  const product = products.find(p => p.id === contract.contractDetails!.productId);
  const productRelevance = product?.value.relevance?.split(",") ?? [];
  return (
    productRelevance.includes("inkaso") &&
    (contract.paymentInfo?.depositType !== PaymentTypeValues.Inkaso ||
      contract.paymentInfo.overpaidType !== PaymentTypeValues.Inkaso)
  );
};

export const skipToRecapitulation = (contract: Contract, processReasonFromURl: string | null) => {
  if (contract.requestStatus === RequestStatusType.SAVED || contract.requestStatus === RequestStatusType.EDITING) {
    return false;
  }
  if (
    [
      RequestStatusType.SUBMITTED,
      RequestStatusType.ACCEPTED,
      RequestStatusType.FOR_APPROVAL,
      RequestStatusType.FINISHED,
    ].includes(contract.requestStatus ?? "") &&
    contract.processReason !== processReasonFromURl
  ) {
    return true;
  }

  return !isValidRequestStatus(contract);
};

export const skipTariffAndPayments = (contract: Contract) => {
  return contract.segment === Segment.B2B && contract.phase === Phase.LEAD;
};

export const skipSupplyPoint = (contract: Contract) => {
  if (!isS3PreviousCustomer(contract)) {
    return false;
  }
  return contract.supplyPoint.measurementType === "B" || isLDSEanOrEic(contract, contract.supplyPoint.code);
};

export const psRequestWelcomeNext = (contract: Contract) => {
  const params = new URLSearchParams(document.location.search);
  if (params.get("phase") === "contract") {
    return `${SCREENS.SUPPLY_POINT_CONFIRM}?${params.toString()}`;
  }
  if (skipToRecapitulation(contract, params.get("process_reason"))) {
    return SCREENS.RECAPITULATION;
  }

  return SCREENS.CUSTOMER;
};
